import { render, staticRenderFns } from "./RegisterReserve.vue?vue&type=template&id=dc7154cc&scoped=true&"
import script from "./RegisterReserve.vue?vue&type=script&lang=js&"
export * from "./RegisterReserve.vue?vue&type=script&lang=js&"
import style0 from "./RegisterReserve.vue?vue&type=style&index=0&id=dc7154cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc7154cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VCard,VCol,VForm})
